import { AddGroupChatScreenNavigationProps } from "./types"
import React from "react"
import AddGroupChat from "./add-group-chat-screen"
import { PageRoot } from "~screens/page-root"


const AddGroupChatScreen: React.FC<AddGroupChatScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <AddGroupChat />
    </PageRoot>
  )
}

export default AddGroupChatScreen
